import { render } from "./AtFooter.vue?vue&type=template&id=714ce6c4&ts=true"
import script from "./AtFooter.vue?vue&type=script&lang=ts"
export * from "./AtFooter.vue?vue&type=script&lang=ts"

import "./AtFooter.vue?vue&type=style&index=0&id=714ce6c4&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/TEU5NrXs6/1/developers/main/tms.engine/web.js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__